import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { USER_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { role_get_select } from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  emailid: Yup.string()
    .required("Role name is required")
    .min(2, "Role name must be at least 2 characters"),
});
const UsersForm: React.FC<HeaderProps> = ({ dataIn, loadTableData }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: dataIn,
  });
  const { closeModal } = useSiteContext();

  const [allRole, setAllRole] = useState([]);

  useEffect(() => {
    role_get_select((data: any) => setAllRole(data));
  }, []);

  //   const onSubmit = (data: any) => {
  //     console.log("Form submitted:", data);
  //   };
  const onSubmit = (data: any) => {
    let url = USER_URLS.INSERT;
    if (dataIn.ID !== undefined) {
      data["id"] = dataIn.ID;
      url = USER_URLS.UPDATE;
    }
    const subscription = post(url, data).subscribe((response) => {
      //console.log("response form ", response.data);
      closeModal(); loadTableData();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const options = [
    { value: "1", label: "Test" },
    { value: "2", label: "Test" },
    { value: "3", label: "test" },
  ];
  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 6,
      name: "emailid",
      element: {
        label: "Email ID",
        isRequired: true,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "ename",
      element: {
        label: "Name",

        isRequired: true,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "mobile_no",
      element: {
        label: "Mobile No.",
        isRequired: true,
        // inputType: "BORDER_LABEL",
        // disabled: !!dataIn.ID,

        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "PASSWORD",
      width: 6,
      name: "epassword",
      element: {
        label: "Password",
        isRequired: true,
        placeHolder: "Password",
        disabled: !!dataIn.ID,
        inputType: "BORDER_LABEL",
      },
      hideFunction: () => !!dataIn.ID, 
    },
    
    {
      type: "SELECT_BOX",
      width: 6,
      name: "role",
      element: {
        label: "Role",
        //  inputType: "BORDER_LABEL",
        options: allRole,
        isMulti: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-hims-input">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default UsersForm;
